// extracted by css-extract-rspack-plugin
export default {"wrapper":"_ac81cd09","topSalesTable":"_ba505d27","itemLink":"_3693492f","itemThumbnail":"_fa612223","itemTitle":"_f8496fcf"};